// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  // PASTE_YOUR_CONFIG_HERE
  apiKey: "AIzaSyCjIlobtj0wuRcKCYLXTQtNeCW6Jy133SU",
  authDomain: "trend-genie-11dac.firebaseapp.com",
  projectId: "trend-genie-11dac",
  storageBucket: "trend-genie-11dac.firebasestorage.app",
  messagingSenderId: "150282620199",
  appId: "1:150282620199:web:5d8a249a5b6356ec9f6d02",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };